module.exports = __webpack_public_path__ + "static/media/video-camera-fill.41782a9c.svg";